jQuery(document).ready(function ($) {

    /**
    * Sets up icon filtering, search, and copy functionality
    * Iterates through all icon holders and:
    * - Enables click-to-copy functionality for icon titles with feedback via snackbar
    * - Filters icons by their data-icon-set attribute
    * - Connects search input (#iconSearch) and selector (#iconSelector) to filter icons dynamically
    * - Sets a minimum height on the preview container to prevent page jump when filtering
    * @returns {void}
    */
    function setupIconFiltering() {
        $('.bocss-icon__preview .bocss-icon__holder').each(function () {
            let $this = $(this);
            let iconTitle = $(this).find('.bocss-icon__title');

            //Set up the copy code click
            $this.click(function () {
                let inp = document.createElement('input');
                document.body.appendChild(inp);
                inp.value = iconTitle.text();
                inp.select();
                document.execCommand('copy', false);
                inp.remove();

                let snackbar = document.getElementById('snackbar');
                snackbar.className = 'show';

                //Hide 'Copied!' after 3 seconds
                setTimeout(function () {
                    snackbar.className = snackbar.className.replace('show', '');
                }, 3000);
            });

            // Display only those icons belonging to the default icon set
            let iconSet = $this.attr('data-icon-set');

            // Fallback: check for data-icon-set on nested .bocss-icon element if not found on holder
            if (!iconSet) {
                iconSet = $(this).find('.bocss-icon').attr('data-icon-set');
            }

            // Skip this element if we still can't find the icon set
            if (!iconSet) {
                return;
            }

            let defaultSet = $('#iconSelector').val();
            $this.toggle(iconSet.localeCompare(defaultSet) === 0);

            // Search and selector functionality
            $('#iconSearch, #iconSelector').on('keyup change', function () {
                let searchValue = $('#iconSearch').val().toLowerCase();
                let selectedSet = $('#iconSelector').val();

                $($this).filter(function () {
                    let matchesSearch = $(this).text().toLowerCase().indexOf(searchValue) > -1;
                    // Get the current icon set (in case it was updated or needs to be re-read)
                    let currentIconSet =
                        $(this).find('.bocss-icon').attr('data-icon-set') || $(this).attr('data-icon-set');
                    let matchesFilter = currentIconSet && currentIconSet.localeCompare(selectedSet) === 0;

                    $(this).toggle(matchesSearch && matchesFilter);
                });
            });
        });

        // Added to avoid page jump when searching
        var minHeight = $('.bocss-icon__preview').height();
        $('#preview_container').css('min-height', minHeight);
    }

    /**
     * Initializes icon filtering and setup
     * Checks if icon holders exist and sets up the filtering, search, and copy functionality.
     * This function is called both immediately for non-React rendering and via MutationObserver
     * for React-rendered components.
     * @returns {boolean} Returns true if icons were successfully initialized, false otherwise
     */
    function initializeIcons() {
        const iconHolders = $('.bocss-icon__holder');

        if (iconHolders.length > 0) {
            setupIconFiltering();
            return true;
        }
        return false;
    }

    // Try immediate initialization (for non-React rendering)
    if (initializeIcons()) {
        return;
    }

    // If icons aren't ready yet, wait for React to mount them
    const observer = new MutationObserver(function() {
        if (initializeIcons()) {
            observer.disconnect();
        }
    });

    const previewContainer = document.getElementById('preview_container');
    if (previewContainer) {
        observer.observe(previewContainer, {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: false
        });

        // Safety timeout in case MutationObserver doesn't catch it
        setTimeout(function() {
            if (observer) {
                observer.disconnect();
                initializeIcons();
            }
        }, 2000);
    }
});
